import {
  GET_FAULT_HISTORY_SUCCESS,
  GET_FAULT_HISTORY_FAILED,
  DETAIL_UPDATE_ERROR,
  DETAIL_UPDATE_SUCCESS,
  CLEAR_STATE,
} from "../actions/types";

const initialState = {
  detailSuccess: "",
  detailError: "",
  faultHistory: [],
  faultHistoryError: "",
  stationList: [],
};

const DetailStationFaults = (state = initialState, action) => {
  switch (action.type) {
    case DETAIL_UPDATE_SUCCESS:
      return {
        ...state,
        detailSuccess: action.payload.message,
      };

    case DETAIL_UPDATE_ERROR:
      return {
        ...state,
        detailError: action.message,
      };

    case GET_FAULT_HISTORY_SUCCESS:
      return {
        ...state,
        faultHistory: action.response.body.pageData,
      };

    case GET_FAULT_HISTORY_FAILED:
      return {
        ...state,
        faultHistoryError: action.message,
      };

    case CLEAR_STATE:
      return {
        ...state,
        detailSuccess: "",
        detailError: "",
      };
    default:
      return state;
  }
};

export default DetailStationFaults;
